import {
    Country,
    COUNTRY_TYPES,
    HeadOfficeCountry,
    LocationCountry,
    RecommendedDealerCountry,
    ResponseCountry,
    SalesPartnerCountry,
    SalesServicePartnerCountry,
    SupportyByCountry,
    SupportyByPartnerCountry,
} from './sew-ws-local-switch.types';

// Typeguards

export const isSupportedByCountry = (country: Country): country is SupportyByCountry => {
    return country.type === COUNTRY_TYPES.SUPPORTED_BY;
};

export const isSupportedByPartnerCountry = (country: Country): country is SupportyByPartnerCountry => {
    return country.type === COUNTRY_TYPES.SUPPORTED_BY_PARTNER;
};

export const isRecommendedDealerCountry = (country: Country): country is RecommendedDealerCountry => {
    return country.type === COUNTRY_TYPES.RECOMMENDED_DEALER;
};

export const isLocationCountry = (country: Country): country is LocationCountry => {
    return country.type === COUNTRY_TYPES.LOCATION;
};

export const isSalesPartnerCountry = (country: Country): country is SalesPartnerCountry => {
    return country.type === COUNTRY_TYPES.SALES_PARTNER;
};

export const isSalesServicePartnerCountry = (country: Country): country is SalesServicePartnerCountry => {
    return country.type === COUNTRY_TYPES.SALES_SERVICE_PARTNER;
};

export const isHeadOfficeCountry = (country: Country): country is HeadOfficeCountry => {
    return country.type === COUNTRY_TYPES.HEAD_OFFICE;
};

export const hasAddress = (
    country: Country
): country is
    | SupportyByPartnerCountry
    | RecommendedDealerCountry
    | LocationCountry
    | SalesPartnerCountry
    | SalesServicePartnerCountry => {
    return 'data' in country && 'address' in country.data;
};

// Functions

export const mapCountry = (country: ResponseCountry): Country => {
    let c: Country = {
        code: country.code,
        name: country.name,
        languages: country.languages,
        type: undefined,
    };
    if (country.recommended_dealer) {
        c = {
            ...c,
            type: COUNTRY_TYPES.RECOMMENDED_DEALER,
            data: { address: country.recommended_dealer.address },
        };
    } else if (country.languages) {
        c = { ...c, type: COUNTRY_TYPES.HEAD_OFFICE };
    } else if (country.sales_partner) {
        c = {
            ...c,
            type: COUNTRY_TYPES.SALES_PARTNER,
            data: { address: country.sales_partner.address },
        };
    } else if (country.location) {
        c = {
            ...c,
            type: COUNTRY_TYPES.LOCATION,
            data: { address: country.location.address },
        };
    } else if (country.sales_service_partner) {
        c = {
            ...c,
            type: COUNTRY_TYPES.SALES_SERVICE_PARTNER,
            data: { address: country.sales_service_partner.address },
        };
    } else if (country.supported_by) {
        if (country.supported_by.languages) {
            c = {
                ...c,
                type: COUNTRY_TYPES.SUPPORTED_BY,
                data: {
                    code: country.supported_by.code,
                    country: country.supported_by.country,
                    languages: country.supported_by.languages,
                },
            };
        } else {
            c = {
                ...c,
                type: COUNTRY_TYPES.SUPPORTED_BY_PARTNER,
                data: {
                    code: country.supported_by.code,
                    country: country.supported_by.country,
                    address: country.supported_by.address,
                },
            };
        }
    }

    return c;
};
